import type {DayOptimisationJobTypeSummary, OverallOptimisationJobTypeSummary} from '../types';
import type {SegmentedColumnChartDataColumn} from 'shared/components/kp-charts/bar-chart/types';
import type {Currency} from 'typings/portaro.be.types';
import type {DonutChartDataPoint} from 'shared/components/kp-charts/donut-chart/types';
import {getColorFromString} from 'src/shared/utils/color-util';
import {KpCalendarManager} from 'src/shared/components/kp-calendar/kp-calendar-manager';

const jobColorLightness = 70;

const czkCurrency: Currency = {
    id: 'CZK',
    text: 'Kč',
    name: 'Kč',
    exchangeRate: 24.5,
    order: 0
};

export const dayOptimisationOverviewJobTypeSummariesMockData: DayOptimisationJobTypeSummary[] = [
    generateMockDayJobTypeSummary('Technik strojní'),
    generateMockDayJobTypeSummary('Zámečník'),
    generateMockDayJobTypeSummary('Požární hlídka'),
    generateMockDayJobTypeSummary('Řezání vodním paprskem CNC'),
    generateMockDayJobTypeSummary('Rovnání do lisu 400t')
];

export const overallOptimisationOverviewJobTypeSummariesMockData: OverallOptimisationJobTypeSummary[] = [
    generateMockOverallJobTypeSummary('Technik strojní'),
    generateMockOverallJobTypeSummary('Zámečník'),
    generateMockOverallJobTypeSummary('Požární hlídka'),
    generateMockOverallJobTypeSummary('Řezání vodním paprskem CNC'),
    generateMockOverallJobTypeSummary('Rovnání do lisu 400t')
];

function generateMockDayJobTypeSummary(jobName: string): DayOptimisationJobTypeSummary {
    return {
        name: jobName,

        reportedWorkersCount: 10,
        chargedWorkersCount: 12,

        reportedStandardHours: 10,
        reportedOvertimeHours: 10,
        reportedWeekendHours: 10,
        reportedHolidayHours: 10,

        chargedStandardHours: 15,
        chargedOvertimeHours: 15,
        chargedWeekendHours: 15,
        chargedHolidayHours: 15,

        reportedStandardRate: {
            amount: 400,
            currency: czkCurrency
        },
        reportedOvertimeRate: {
            amount: 400,
            currency: czkCurrency
        },
        reportedWeekendRate: {
            amount: 400,
            currency: czkCurrency
        },
        reportedHolidayRate: {
            amount: 400,
            currency: czkCurrency
        },

        chargedStandardRate: {
            amount: 550,
            currency: czkCurrency
        },
        chargedOvertimeRate: {
            amount: 550,
            currency: czkCurrency
        },
        chargedWeekendRate: {
            amount: 550,
            currency: czkCurrency
        },
        chargedHolidayRate: {
            amount: 550,
            currency: czkCurrency
        },

        reportedPrice: {
            amount: 80600,
            currency: czkCurrency
        },
        chargedPrice: {
            amount: 110000,
            currency: czkCurrency
        }
    };
}

function generateMockOverallJobTypeSummary(jobName: string): OverallOptimisationJobTypeSummary {
    return {
        name: jobName,

        reportedStandardHours: 100,
        reportedOvertimeHours: 100,

        chargedStandardHours: 150,
        chargedOvertimeHours: 150,

        reportedStandardRate: {
            amount: 400,
            currency: czkCurrency
        },
        reportedOvertimeRate: {
            amount: 400,
            currency: czkCurrency
        },

        chargedStandardRate: {
            amount: 550,
            currency: czkCurrency
        },
        chargedOvertimeRate: {
            amount: 550,
            currency: czkCurrency
        },

        reportedPrice: {
            amount: 400 * 200,
            currency: czkCurrency
        },
        chargedPrice: {
            amount: 550 * 300,
            currency: czkCurrency
        }
    }
}

export function generateMockSegmentedData(): SegmentedColumnChartDataColumn[] {
    const calendarDays = KpCalendarManager.createCalendarData({
        granularity: 'day',
        from: {day: 29, month: 3, year: 2025},
        to: {day: 11, month: 4, year: 2025}
    });

    return calendarDays.map((calendarDay) => {
        const random = Math.random();

        return {
            label: `${calendarDay.day}.${calendarDay.month}.`,
            segments: [
                {label: 'Účtované náklady', value: 20 * random, color: '#F3BDA7'},
                {label: 'Vykázané náklady', value: 80 * random, color: '#D9E1F6'}
            ]
        };
    });
}

export function generateMockDonutData(): DonutChartDataPoint[] {
    return dayOptimisationOverviewJobTypeSummariesMockData.map((jobTypeSummary) => {
        return {
            label: jobTypeSummary.name,
            value: jobTypeSummary.chargedPrice.amount,
            color: getColorFromString(jobTypeSummary.name, jobColorLightness)
        };
    });
}